import { Col, Image, Row, Modal } from "antd";
import React, { useState } from "react";
import Header from "../header/header";

const commerciallist = [
  {
    src: "Sources/images/prouctlist/commercial/ongoing/Regalia2.png",
    title: "REGALIA 2",
    segment: "Commercial",
    client: "Nakshtra Infraspace",
    location: "GIFT City",
    architect: "ARK - Reza Kabul Architects Pvt. Ltd.",
    consultant: "Sarjan Consultant",
    projectSize: "15,90,000 Sq. ft.",
    projectDes: "5B+GF+28 Floor",
    projectYear: "2025",
    scope:
      "RCC Frame works, Masonary, Plaster works, waterproofing, MEP work,Flooring works etc.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/ShivalikWave.png",
    title: "SHIVALIK WAVE",
    segment: "Commercial",
    client: "Shivalik Group",
    location: "Ahmedabad",
    architect: "Apurva Amin",
    consultant: "N.K. Shah Consulting Engineers LLP",
    projectSize: "12,59,000 Sq. ft.",
    projectDes: "3B+GF+29 Floor",
    projectYear: "2025",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/VasupujyaSuratprojects2.jpeg",
    title: "VASUPUJYA RIO CREST",
    segment: "Commercial",
    client: "Vasupujya Structural",
    location: "Surat",
    architect: "M/S Tathastu Architect",
    consultant: "Epicons Consultants Pvt Ltd.",
    projectSize: "7,50,000 Sq. ft.",
    projectDes: "3B+GF+39 Floor",
    projectYear: "2025",
    scope: "RCC Frame works",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/Sharnam_navkar.jpeg",
    title: "SHARNAM NAVKAR",
    segment: "Commercial",
    client: "Sharnam Group",
    location: "Ahmedabad",
    architect: "99 Studio",
    consultant: "Shreeji Structure",
    projectSize: "7,16,600 Sq. ft.",
    projectDes: "3B+GF+07/05 Floor",
    projectYear: "2025",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/Citadel.png",
    title: "THE CITADEL",
    segment: "Commercial",
    client: "Magnastar Realty",
    location: "Ahmedabad",
    architect: "Architect Mansi Shah",
    consultant: "Ducon Consultants Pvt Ltd",
    projectSize: "7,12,300 Sq. ft",
    projectDes: "3B+GF+19 Floor",
    projectYear: "2024",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/UniversalMajesty.png",
    title: "THE MAJESTY",
    segment: "Commercial",
    client: "Majesty Infra",
    location: "Surat",
    architect: "Tathastu Architect Surat",
    consultant: "CBM Engineers",
    projectSize: "6,39,000 Sq. ft.",
    projectDes: "3B+GF+17 Floor",
    projectYear: "2025",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  //  {
  //   src: "Sources/images/prouctlist/commercial/ongoing/WealthPicture.png",
  //   title: "WEALTH CITY",
  //   segment: "Commercial",
  //   client: "Wealth City Devlopers",
  //   location: "Surat",
  //   architect: "Tathastu Architect Surat",
  //   consultant: "SNV Engineers",
  //   projectSize: "5,97,000 Sq. ft.",
  //   projectDes: "3B+GF+11 Floor",
  //   projectYear: "2025-Current",
  //   scope: "Excavation work, RCC Frame works, Masonary & Plaster works.",
  // },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/devx/2.jpg",
    title: "DEVX",
    segment: "Commercial",
    client: "DevX",
    location: "Ahmedabad",
    architect: "Upkrama Design LLP",
    consultant: "Ducon Consultant Private Limited",
    projectSize: "4,82,000 Sq. ft.",
    projectDes: "3B+GF+11 Floor",
    projectYear: "2024",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing, LPS works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/UCC.png",
    title: "UNIVERSAL COMMERCIAL CAPITAL",
    segment: "Commercial",
    client: "UCC Infra",
    location: "Surat",
    architect: "Tathastu Architects Surat",
    consultant: "CBM Engineers",
    projectSize: "3,26,000 Sq. ft",
    projectDes: "3B+GF+11 Floor",
    projectYear: "2024",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  // {
  //   src: "Sources/images/prouctlist/commercial/ongoing/AdaniWilmarNew.png",
  //   title: "ADANI WILMAR HEADQUARTER",
  //   segment: "Commercial",
  //   client: "Adani Realty",
  //   location: "Adani Shantigram, Ahmedabad",
  //   architect: "Eric Parry Architects",
  //   consultant: "Ducon Consultant Private Limited.",
  //   projectSize: "4,85,000 Sq. ft.",
  //   projectDes: "3B+GF+08 Floor",
  //   projectYear: "2024-Current",
  //   scope: "RCC Frame works, Masonary, Plaster works, Waterproofing, LPS works.",
  // },
];

const commercialcompleted = [
  {
    src: "Sources/images/prouctlist/commercial/completed/11.png",
    title: "SUMEL 8",
    segment: "Commercial",
    client: "HN Safal",
    location: "Ahmedabad",
    architect: "ADS Architects Pvt Ltd",
    consultant: "N.K. Shah Consulting Engineers LLP",
    projectSize: "16,00,000 Sq. ft.",
    projectDes: "1B+GF+5 Floor",
    projectYear: "2017",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/13.jpg",
    title: "SUN WEST BANK",
    segment: "Commercial",
    client: "Sun Builders",
    location: "Ahmedabad",
    architect: "HM Architect",
    consultant: "SETU Infrastructure",
    projectSize: "6,85,000 Sq. ft.",
    projectDes: "3B+GF+13 Floor",
    projectYear: "2021",
    scope:
      "RCC Frame works, Masonary, Plaster works, waterproofing, MEP work, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/2.png",
    title: "KP EPITOME",
    segment: "Commercial",
    client: "KP Sanghvi Group",
    location: "Ahmedabad",
    architect: "99 Studio",
    consultant: "P-Cube Consultant",
    projectSize: "6,00,000 Sq. ft.",
    projectDes: "2B+GF+14 Floor",
    projectYear: "2021",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/Ratnakar Nine Square/Ratnakar Nine - Main.jpg",
    title: "RATNAAKAR NINE SQUARE",
    segment: "Commercial",
    client: "Ratnakar Group",
    location: "Ahmedabad",
    architect: "ADS Architect Pvt Ltd",
    consultant: "Ducon Consultant Pvt Ltd",
    projectSize: "6,00,000 Sq. ft.",
    projectDes: "3B+GF+13 Floor",
    projectYear: "2018",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/1-4.png",
    title: "FLEXONE",
    segment: "Commercial",
    client: "Collated Ventures",
    location: "GIFT City",
    architect: "Studio ARA",
    consultant: "N.K. Shah Consulting Engineers LLP",
    projectSize: "5,63,000 Sq. ft.",
    projectDes: "3B+GF+28 Floor",
    projectYear: "2022",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing, Flooring works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/West Gate Business Bay/Picture11.jpg",
    title: "WEST GATE BUSINESS BAY",
    segment: "Commercial",
    client: "Aadhan Builders",
    location: "Ahmedabad",
    architect: "ADS Architect Pvt Ltd",
    consultant: "N.K. Shah Consulting Engineers LLP",
    projectSize: "5,36,000 Sq. ft.",
    projectDes: "3B+GF+16 Floor",
    projectYear: "2018",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/Regalia2.jpeg",
    title: "REGALIA",
    segment: "Commercial",
    client: "Nakshtra Infraspace",
    location: "GIFT City",
    architect: "Neha Consultants",
    consultant: "J W Consultants LLP",
    projectSize: "5,00,000 Sq. ft.",
    projectDes: "3B+GF+29 Floor",
    projectYear: "2025",
    scope: "RCC Frame works, Masonary, Plaster works, Flooring works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/12.jpg",
    title: "WEST GATE",
    segment: "Commercial",
    client: "Aadhan Builders",
    location: "Ahmedabad",
    architect: "ADS Architects Pvt Ltd",
    consultant: "N.K. Shah Consulting Engineers LLP",
    projectSize: "5,00,000 Sq. ft.",
    projectDes: "3B+GF+23/14 Floor",
    projectYear: "2014",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/SharnamMetrolink.webp",
    title: "SHARANAM METROLINK",
    segment: "Commercial",
    client: "Sharanam Metrolink LLP",
    location: "Ahmedabad",
    architect: "99 Studio",
    consultant: "Shreeji Consultant",
    projectSize: "4,91,000 Sq. ft.",
    projectDes: "2 Floors, 12 Meters",
    projectYear: "2024",
    scope:
      "Civil Construction work of RCC Frame, Block & Plaster work, Flooring Work, painting Work, Fabrication work.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/West Gate D Block/Picture12.jpg",
    title: "WEST GATE - D BLOCK",
    segment: "Commercial",
    client: "Aadhan Builders",
    location: "Ahmedabad",
    architect: "ADS Architects Pvt Ltd",
    consultant: "N.K. Shah Consulting Engineers LLP",
    projectSize: "4,85,000 Sq. ft.",
    projectDes: "3B+GF+23 Floor",
    projectYear: "2019",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/shivalik-shilp2/2.jpg",
    title: "SHIVALIK SHILP 2",
    segment: "Commercial",
    client: "Shilp Developers",
    location: "Ahmedabad",
    architect: "INI Design Studio",
    consultant: "Ducon Consultant Pvt Ltd",
    projectSize: "4,72,000",
    projectDes: "13 Floors, 48 Meters",
    projectYear: "2019",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
  {
    src: "/Sources/images/prouctlist/residential/completed/yash arian/003.jpg",
    title: "YASH ARIAN ",
    imageGallery: [
      "/Sources/images/prouctlist/residential/completed/yash arian/002.jpg",
      "/Sources/images/prouctlist/residential/completed/yash arian/003.jpg",
      "/Sources/images/prouctlist/residential/completed/yash arian/1.jpg",
    ],
    content:
      "Yash Arian is a project with several modern amenities.It comes with a total of 204 spacious and luxurious apartments.",
    client: "Yash Arian Infra LLP",
    location: "Ahmedabad",
    projectSize: "4,50,000 Sq. ft.",
    projectDes: "2B+GF+14 Floor",
    projectYear: "2017",
    architect: "Design Studio",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/5.png",
    title: "SHARNAM SMART SPACE",
    segment: "Commercial",
    client: "Sharnam Group",
    location: "Ahmedabad",
    architect: "99 studio",
    consultant: "Millimeter designs",
    projectSize: "4,25,000 Sq. ft.",
    projectDes: "2B+GF+4 Floor",
    projectYear: "2019",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/sharnam sq/1.jpg",
    title: "SHARNAM SQUARE",
    segment: "Commercial",
    client: "Sharnam Group",
    location: "Ahmedabad",
    architect: "99 Studio",
    consultant: "Shreeji Consultant",
    projectSize: "2,75,000 Sq. ft.",
    projectDes: "1B+GF+02 Floor",
    projectYear: "2024",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/14.jpg",
    title: "SHARNAM SOLITAIRE",
    segment: "Commercial",
    client: "Sharnam Group",
    location: "Ahmedabad",
    architect: "99 Studio",
    consultant: "Millimeter Designs",
    projectSize: "2,25,000 Sq. ft.",
    projectDes: "1B+GF+4 Floor",
    projectYear: "2021",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/commercial/completed/1.png",
    title: "AHMEDABAD ONE MALL - PHASE 2",
    segment: "Commercial",
    client: "Nexus Mall",
    location: "Ahmedabad",
    architect: "Bentel Associates",
    consultant: "TPC Technical Projects Consultants",
    projectSize: "2,00,000 Sq. ft.",
    projectDes: "2B+GF+4 Floor",
    projectYear: "2022",
    scope:
      "RCC Frame works, Masonary, Plaster works & Structural Steel Work & Structural Retrofitting Work.",
  },
  {
    src: "Sources/images/prouctlist/commercial/ongoing/TheProfit.jpeg",
    title: "THE PROFIT",
    segment: "Commercial",
    client: "The Building Company",
    location: "Surat",
    architect: "Tathastu Architect Surat",
    consultant: "SNV Engineers",
    projectSize: "1,59,000 Sq. ft.",
    projectDes: "2B+GF+10 Floor",
    projectYear: "2024",
    scope: "RCC Frame works, Masonary & Plaster works.",
  },
];

const Commercial = () => {
  const [isOngoing, setIsOngoing] = useState(true);
  const [isCompleted, setIsCompleted] = useState(false);
  const [expandedOngoing, setExpandedOngoing] = useState(null);
  const [expandedCompleted, setExpandedCompleted] = useState(null);

  const toggleOngoing = (key) => {
    if (expandedOngoing === key) {
      setExpandedOngoing(null);
    } else {
      setExpandedOngoing(key);
    }
  };

  const toggleCompleted = (key) => {
    if (expandedCompleted === key) {
      setExpandedCompleted(null);
    } else {
      setExpandedCompleted(key);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);

  const showModal = (item) => {
    setModalDetails(item);
    setIsModalOpen(true);
    console.log("open");
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setModalDetails(null);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setModalDetails(null);
  };

  return (
    <>
      <img
        src="Sources/images/prouctlist/commercial/commercial.JPG"
        alt="404 -Not Given"
        className="about_img"
      />

      <div className="projects-bg">
        {/* <Header /> */}
        <section className="residential py-5">
          <div className="container">
            <p
              style={{ color: "#0d2e61" }}
              className="is-size-1 has-text-weight-semibold has-text-centered  is-uppercase"
            >
              Commercial Projects
            </p>
            <div>
              <Row>
                <Col>
                  <p
                    className="is-size-5 has-text-weight-semibold blue_color mb-2 is-uppercase ongoing-projects"
                    onClick={() => {
                      setIsCompleted(false);
                      setIsOngoing(true);
                    }}
                    style={{
                      borderBottom: isOngoing ? "2px solid #0d2e61" : "none",
                    }}
                  >
                    Ongoing
                  </p>
                </Col>
                <Col>
                  <p
                    className="is-size-5 has-text-weight-semibold blue_color mb-2 is-uppercase completed-projects"
                    onClick={() => {
                      setIsOngoing(false);
                      setIsCompleted(true);
                    }}
                    style={{
                      borderBottom: isCompleted ? "2px solid #0d2e61" : "none",
                    }}
                  >
                    Completed
                  </p>
                </Col>
              </Row>
            </div>
          </div>
        </section>

        <section className="residential pt-0">
          <div className="container">
            <div>
              <Row>
                {isOngoing &&
                  commerciallist.map((item, key) => {
                    return (
                      <Col xxl={8} lg={8} md={12} sm={24} xs={24} key={key}>
                        <div
                          className="property_list"
                          style={{ minHeight: "200px" }}
                        >
                          <div className="propertylist_image">
                            <Image
                              src={item.src}
                              alt="404 - Not Given"
                              preview={{
                                getContainer: "#root",
                              }}
                            />
                          </div>

                          <div className="propertylist_content p-4">
                            <div className="pt-2">
                              <p className="is-size-4 has-text-centered blue_color has-text-weight-semibold text-uppercase project_title_two_line">
                                {item.title}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">{item.content}</p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Client:&nbsp;
                                </span>
                                {item.client}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Location:&nbsp;
                                </span>
                                {item.location}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Project Size:&nbsp;
                                </span>
                                {item.projectSize}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Project Description:&nbsp;
                                </span>
                                {item.projectDes}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Project Year:&nbsp;
                                </span>
                                {item.projectYear}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Architect:&nbsp;
                                </span>
                                {item.architect}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Str. Consultant:&nbsp;
                                </span>
                                {item.consultant}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Scope:&nbsp;
                                </span>
                                {item.scope}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
              </Row>
            </div>
            <div>
              <Row>
                {isCompleted &&
                  commercialcompleted.map((item, key) => {
                    return (
                      <Col xxl={8} lg={8} md={12} sm={24} xs={24} key={key}>
                        <div
                          className="property_list"
                          style={{ minHeight: "200px" }}
                        >
                          <div className="propertylist_image">
                            <Image
                              src={item.src}
                              alt="404 - Not Given"
                              preview={{
                                getContainer: "#root",
                              }}
                            />
                          </div>

                          <div className="propertylist_content p-4">
                            <div className="pt-2">
                              <p className="is-size-4 has-text-centered blue_color has-text-weight-semibold project_title_two_line">
                                {item.title}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Client:&nbsp;
                                </span>
                                {item.client}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Location:&nbsp;
                                </span>
                                {item.location}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Project Size:&nbsp;
                                </span>
                                {item.projectSize}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Project Description:&nbsp;
                                </span>
                                {item.projectDes}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Completed Year:&nbsp;
                                </span>
                                {item.projectYear}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Architect:&nbsp;
                                </span>
                                {item.architect}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Str. Consultant:&nbsp;
                                </span>
                                {item.consultant}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Scope:&nbsp;
                                </span>
                                {item.scope}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
              </Row>
              {modalDetails && (
                <Modal
                  getContainer="#root"
                  title={modalDetails.title}
                  open={isModalOpen}
                  footer={null}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  mask={true}
                  style={{ boxShadow: "none" }}
                  width={1000}
                >
                  <Row>
                    {modalDetails.imageGallery &&
                    modalDetails.imageGallery.length > 0 ? (
                      modalDetails.imageGallery.map((imgSrc, idx) => (
                        <Col lg={8} key={idx}>
                          <div className="image_position">
                            <Image
                              src={imgSrc}
                              alt={`Gallery Image ${idx + 1}`}
                              style={{ cursor: "pointer" }}
                              preview={{
                                getContainer: "#root",
                              }}
                            />
                          </div>
                        </Col>
                      ))
                    ) : (
                      <p>No images found</p>
                    )}
                  </Row>
                </Modal>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Commercial;
